import request from '@/utils/request'
import defaultSettings from '../settings'

//账号安全路径
export const securityPath = `/user/security`;

/**
 * 获取用户详细信息
  */
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

/**
 * 获取登录用户详细信息
 */
export function getLoginUserInfo() {
    return request({
        url: `/api/user/info`,
        method: 'get'
    });
}

/**
 * 获取用户权限字符串
 */
export function getLoginUserPermissions() {
    let scopeName = '泰迪内推';
    return request({
        url: `/api/user/permissions?subsystemName=${scopeName}`,
        method: 'get'
    });
}

/**
 * 获取登录用户详细信息
 */
export function getEnterpriseAdmin() {
    return request({
        url: `/api/enterprise/admin`,
        method: 'get'
    });
}

/**
 * 获取登录用户权限信息
 */
export function checkSysManage() {
    return request({
        url: `/user/checkSysManage`,
        method: 'get'
    });
}

/**
 * 获取登录用户权限信息
 */
export function getResources() {
    let scopeName = '泰迪内推';
    return request({
        url: `/api/user/resources?name=${scopeName}`,
        method: 'get'
    });
}

/**
 * 修改用户信息
 */
export function updateUserInfo(params){
    return request({
        url: `/api/user/updateInfo`,
        method: 'put',
        data: params
    });
}

/**
 * 退出登录
 */
export function logout(){
    return request({
        url: `/logout`,
        method: 'get'
    })
}

/**
 * 登录
 */
export function login(){
    return request({
        url: `/login`,
        method: 'get'
    })
}

/**
 * 获取路由菜单-从setting中获取预定义菜单
  */
export const getRouters = () => {
  return new Promise((resolve, reject) => {
    var menu = {"msg":"操作成功","code":200,"data": defaultSettings.menuList}
    resolve(menu)
  });

}

/**
 * 修改用户密码
 */
export function updatePassword(token,params){
    return request({
        url: `/api/user/password?token=${token}`,
        method: 'put',
        data:params
    });
}
